import transactionsSlice from '@/containers/Accounts/redux/transactions.slice';
import canvassersSlice from '@/containers/Canvassers/redux/canvassers.slice';
import contactListsSlice from '@/containers/ContactLists/redux/contactLists.slice';
import identityRegistrationSlice from '@/containers/Identities/redux/identityRegistration.slice';
import jobEditorsSlice from '@/containers/Jobs/redux/jobEditors.slice';
import mediaManagerSlice from '@/containers/MediaManager/redux/mediaManager.slice';
import modalsSlice from '@/containers/Modals/redux/modals.slice';
import optOutManagerSlice from '@/containers/OptOutManager/redux/optOutManager.slice';
import toastSlice from '@/containers/ToastMessage/store/toastSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import appSlice from './app.slice';

// Combine reducers
const rootReducer = combineReducers({
  [appSlice.name]: appSlice.reducer,
  [modalsSlice.name]: modalsSlice.reducer,
  [jobEditorsSlice.name]: jobEditorsSlice.reducer,
  [contactListsSlice.name]: contactListsSlice.reducer,
  [canvassersSlice.name]: canvassersSlice.reducer,
  [optOutManagerSlice.name]: optOutManagerSlice.reducer,
  [toastSlice.name]: toastSlice.reducer,
  [transactionsSlice.name]: transactionsSlice.reducer,
  mediaManager: mediaManagerSlice,
  [identityRegistrationSlice.name]: identityRegistrationSlice.reducer,
});

// Configure store
const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
